import React, { useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { Button, Message } from "../../../BP2Components";
import "../GlobalSettings/GlobalSettings.less";

export const cartDataSettingsList = [
   "titleColumn",
   "currencyColumn",
   "photoColumn",
   "category_1Column",
   "category_2Column",
   "category_3Column",
   "orderTypeColumn",
   "unit_priceColumn",
   "quantityColumn",
   "amountColumn",
   "item_idColumn"
];

const BasketDataSettings = ({ columns, value }) => {
   const [settings, setSettings] = useState({ ...value });

   const { Option } = Select;
   const dispatch = useDispatch();
   const intl = useIntl();

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChange = (value, name) => {
      setSettings(() => ({ ...settings, [name]: value }));
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="basketSettings" className="widget-settings__inner">
                  {cartDataSettingsList.map((labelName) => {
                     return (
                        <label key={labelName} className="widget-settings__inner__label">
                           <IntlMessages id={`cart.${labelName}`} />:
                           <Select
                              allowClear
                              value={settings[labelName]}
                              onChange={(e) => handleChange(e, labelName)}
                           >
                              {columns?.map(({ title, techName }, i) => (
                                 <Option value={techName} key={i}>
                                    {title}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                     );
                  })}
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default BasketDataSettings;
